import React from "react";
import {Stack, Typography} from "@mui/material";
import {BpChart} from "../Charts/BpChart";
import Grid from "@mui/material/Grid";
import {bpReadings} from "./BpSection";


export const BpCard = ({max,min,name,color,state} : bpReadings) =>{
    return(
        <Grid item lg={2} md={4} >
            <Stack
                sx={{background:color,padding:"20px"}}
                direction="row" spacing={1} className="card-blood-pressure"  justifyContent="space-between">
                <Stack>
                    <Typography
                        fontSize={16}
                    >
                        {min}-{max}
                    </Typography>
                    <Typography
                        fontSize={16}
                    >
                        {name}
                    </Typography>
                </Stack>
                <Stack>
                    <BpChart state={state} />
                    <Typography
                        fontSize={16}
                    >
                        {state}
                    </Typography>
                </Stack>
            </Stack>
        </Grid>
    )
}